console.clear();

var Common = {}
var Page = {}
var Component = {}
